import { FC } from 'react';

import { useListingContext } from 'shared/context/ListingContext';

import { AveragePriceSEOBlock } from './AveragePriceSEOBlock';

export const AveragePriceSEOBlockContainer: FC = () => {
  const {
    seo: {
      view: { averagePrice },
    },
  } = useListingContext();

  if (!averagePrice) {
    return null;
  }

  return <AveragePriceSEOBlock averagePrice={averagePrice} />;
};
